var styles = {
  "Box": "Polaris-Box"
};

export { styles as default };
